import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import MergeTypeIcon from '@material-ui/icons/MergeType';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { MODALS } from 'src/models/ModalModel';
import { openModal } from 'src/redux/actions/modalActions';
import { t } from 'src/lib/language';

const MergeContactMenubutton = (props: ButtonProps) => {
  const { disabled } = props;

  const dispatch = useAppDispatch();
  const lang = useSelector((state: Store) => state.language.language);

  const handleOpen = () => {
    dispatch(openModal({ modal: MODALS.mergeContacts }));
  };

  return (
    <Tooltip
      title={t(lang, 'menus.merge_selected_contact')}
      placement="top-start">
      <span>
        <ActionButton
          data-testid="merge-contact-button"
          variant="outlined"
          category={MENU_BUTTON_CATEGORY.action}
          onClick={handleOpen}
          disabled={disabled}>
          <MergeTypeIcon />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default MergeContactMenubutton;
